import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text, Truncated } from '@frontend/design-system';

type Props = {
  locationName: string;
  maxWidth?: number;
  onRemove?: () => void;
};

export const LocationEntity = ({ locationName, maxWidth, onRemove }: Props) => {
  return (
    <div css={styles.container(maxWidth)}>
      <Icon name='location' size={16} css={{ flexShrink: 0 }} />
      <Truncated as={Text} size='medium'>
        {locationName}
      </Truncated>
      <NakedButton onClick={onRemove} css={styles.closeButton}>
        <Icon name='x' size={8} css={{ flexShrink: 0 }} />
      </NakedButton>
    </div>
  );
};

const styles = {
  container: (maxWidth?: number) => css`
    display: flex;
    align-items: center;
    background-color: ${theme.colors.primary5};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing(1.25, 1)};
    gap: ${theme.spacing(0.5)};
    max-width: ${maxWidth ? `${maxWidth}px` : 'auto'};
  `,
  closeButton: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${theme.spacing(0.5)};
    margin-left: ${theme.spacing(0.5)};
  `,
};
